package one.healthium.content.navigation.main

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.arkivanov.decompose.extensions.compose.stack.Children
import one.healthium.content.navigation.content.ContentContent
import one.healthium.content.navigation.insights.InsightsContent
import one.healthium.content.navigation.shopping_list.ShoppingListContent
import one.healthium.decompose.platformPredictiveBackAnimation

@Composable
fun MainContentContent(component: MainContentComponent) {
    Children(
        modifier = Modifier.fillMaxSize(),
        stack = component.stack,
        animation = platformPredictiveBackAnimation(
            backHandler = component.backHandler,
            onBack = component::onBackClicked,
        )
    ) {
        when (val child = it.instance) {
            is MainContentComponent.Child.Content -> ContentContent(child.component)
            is MainContentComponent.Child.Insights -> InsightsContent(child.component)
            is MainContentComponent.Child.ShoppingList -> ShoppingListContent(child.component)
        }
    }
}